const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'dashboard',
        title: 'Pregled',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard',
        permissions: ['smerinje-view-events'],
        top_level: true
    },
    
    /*
    {
        name: 'settings',
        title: 'Nastavitve',
        icon: 'mdi-cogs',
        path: '/nastavitve',
        group: 'settings',
        permissions: ['smerinje-settings'],
        top_level: true
    },
    */
    
    /*
    {
        title: 'Uporabniki',
        icon: 'mdi-account-group',
        group:'uporabniki',
        permissions: [],
        items: [
            {
                name: 'users_list',
                title: 'Seznam uporabnikov',
                icon: 'mdi-account-group',
                path: '/seznam-uporabnikov',
                group: 'users_list',
                permissions: ['smerinje-view-user'],
                top_level: false
            },
            {
                name: 'add_user',
                title: 'Dodaj uporabnika',
                icon: 'mdi-account-plus',
                path: '/dodaj-uporabnika',
                group: 'add_user',
                permissions: ['smerinje-view-user', 'smerinje-create-user'],
                top_level: false
            },
        ]
    },
    */

    {
        name: 'users_list',
        title: 'Seznam uporabnikov',
        icon: 'mdi-account-group',
        path: '/seznam-uporabnikov',
        group: 'users_list',
        permissions: ['smerinje-view-user'],
        top_level: true
    },
    {
        name: 'add_user',
        title: 'Dodaj uporabnika',
        icon: 'mdi-account-plus',
        path: '/dodaj-uporabnika',
        group: 'add_user',
        permissions: ['smerinje-view-user', 'smerinje-create-user'],
        top_level: true
    },

    /*{
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: '/zasedenost-parkirisca',
        group: 'parking_occupancy',
    },*/

    /*
    {
        name: 'registration-numbers',
        title: 'Enkratni prehodi',
        icon: 'mdi-car-side',
        path: 'enkratni-prehodi/registrske-stevilke',
        group: 'vehicles',
        permissions: ['smerinje-view-registration-number'],
        top_level: true
    },
    */

    {
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: 'zasedenost-parkirisca',
        permissions: ['smerinje-view-parking-occupancy'],
        top_level: true
    },
    
    
    
    {
        title: 'Zapornice',
        icon: 'mdi-remote',
        group: 'zapornice', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['smerinje-parking-barriers'],
        items: [
            {
                name: 'parking_barriers_management',
                title: 'Upravljanje zapornic',
                icon: 'mdi-android-messages',
                path: '/zapornice/upravljanje',
                permissions: ['smerinje-parking-barriers'],
            },

            /*{
                name: 'parking_barriers_timeline',
                title: 'Časovnica',
                icon: 'mdi-android-messages',
                path: '/zapornice/casovnica',
                permissions: ['smerinje-parking-barriers'],
            },*/
            {
                name: 'parking_barriers_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/zapornice/arhiv',
                permissions: ['smerinje-parking-barriers'],
            }
        ]
    },
    

    /*{
        name: 'validator',
        title: 'Validator',
        icon: 'mdi-barcode-scan',
        path: '/validacije',
        group: 'validator',
    }*/

    {
        name: 'exports',
        title: 'Izvoz podatkov',
        icon: 'mdi-application-export',
        path: 'izvoz-podatkov',
        group: 'exports',
        permissions: ['smerinje-data-export'],
        top_level: true
    },
    
]

export { Menu }